"use client";
import React from "react";
const AccordionContext = React.createContext({
    active: false,
    onToggle: () => { },
    triggerId: "",
    contentId: "",
});
export default AccordionContext;
